import React, { useState } from "react";
import { Container, Grid } from '@material-ui/core'
import { HeaderHLPure, DialogSystemGLPure, PromotionalFooterPure, SimpleLoading, Stepper, StepComponent } from "../../pures";
import { useTranslation } from "react-i18next";

import "./signature-base.css";

const SignatureBaseView = (props) => {
    let {
        isLoadingView,
        showLoadingRequesting,
        toggleLoadingRequesting,
        showCompletedRequesting,
        toggleCompletedRequesting,
        showErrorRequesting,
        toggleErrorRequestingFalse,
        messageError,
        selectedStep,
        stepMetadata,
        steps,
        validator,
        setDocumentsSeleceted
    } = props

    const { t } = useTranslation();

    const { component: StepComponent, handleBack, handleNext } = stepMetadata[selectedStep];
    const step = steps[selectedStep];

    const [headerTitle, setHeaderTitle] = useState(t("signatureBaseView.title"))
    const [typePersonId, setTypePersonId] = useState(1)
    const [contractWorkFlow, setContractWorkFlow] = useState({})

    if (isLoadingView) return <div className="standard-wrapper">
        <SimpleLoading />
    </div>

    return (
        <div className="standard-wrapper">
            <Container>
                <Grid container spacing={2}>
                    <div className="signatureBaseView-header">
                        <HeaderHLPure title={headerTitle} />
                    </div>
                    <div className="signatureBaseView-body">
                        <div>
                            <Stepper steps={steps} selectedStep={selectedStep} />
                        </div>
                        <div className="container-step-sigatureRequestProfile">
                            <StepComponent
                                step={step}
                                onHandleNext={handleNext}
                                onHandleBack={handleBack}
                                validator={validator}
                                toggleLoadingRequesting={toggleLoadingRequesting}
                                toggleCompletedRequesting={toggleCompletedRequesting}
                                toggleErrorRequesting={toggleErrorRequestingFalse}
                                setDocumentsSeleceted={setDocumentsSeleceted}
                                setTypePersonId={setTypePersonId}
                                typePersonId={typePersonId}
                                setContractWorkFlow={setContractWorkFlow}
                                contractWorkFlow={contractWorkFlow}
                                t={t}
                                {...props}
                            />
                        </div>
                    </div>
                    <Grid item xs={12} lg={12} md={12} sm={12}>
                        <PromotionalFooterPure />
                    </Grid>
                    <DialogSystemGLPure
                        showLoadingRequesting={showLoadingRequesting}
                        toggleLoadingRequesting={toggleLoadingRequesting}

                        showCompletedRequesting={showCompletedRequesting}
                        toggleCompletedRequesting={toggleCompletedRequesting}

                        showErrorRequesting={showErrorRequesting}
                        toggleErrorRequesting={toggleErrorRequestingFalse}
                        messageError={messageError}
                    />
                </Grid>
            </Container>
        </div>
    )
}

export { SignatureBaseView as default }